angular.module("digitalLeasing.module")
  .component("accordionQva", {
    templateUrl: "ng/components/digitalLeasing/qva/accordionQva/accordionQva.view.html",
    controllerAs: "accordionQvaCtrl",
    bindings: {
      model: "=",
      isEveryQuestionAnswered: "&",
      editable:'<',
      numeroContratto:'<',
      modulo:'<',
      contractSelected:'<',
      snapshot:'<'
    },
    controller: function (
      $userService,
      $modalService,
      $rootScope,
      $location
      ) {
      var self = this;

      self.domande = [{}];


      self.$onInit = function () {
        self.numberOfQuestionsSelected = 0;
        self.numberOfCheckSelected=[];
        self.numberOfRadioSelected=[];

        if (self.model.domande == null || self.model.domande.length == 0) {
          self.getQuestions();
        }else{
          self.count(self.model.domande);
          controlChek();
          controlRadio();
        }

        self.currentQuestion = "";

        self.checkIfIseveryQuestionAnswered();

      };


     
      
      self.updateSelectedAnswer = function (indexAns, indexQue) {

        self.model.domande[indexQue].risposte[indexAns].selected = true;

        self.model.domande[indexQue].risposte.forEach(function (r) {
          if (r != self.model.domande[indexQue].risposte[indexAns]) {
            r.selected = false;
          }
        })


        self.numberOfRadioSelected=[];
        self.model.domande
          .filter(function(element){ 
            return element.tipo == "radio"
          }).forEach(function(f, index){
            self.numberOfRadioSelected[index]= f.risposte.some(function(s){
              return s.selected == true
            })
          })

        self.checkIfIseveryQuestionAnswered();
      }
      
      

      
      self.getQuestions = function () {
        $userService
          .getQVA()
          .then(function (response) {
            self.model.codQuestionario = response.codQuestionario;
            self.model.domande = response.domande
              .map(function (e) {
                return {
                  domanda: e.domanda,
                  cdDomanda: e.cdDomanda,
                  risposte: e.risposte,
                  tipo: e.tipo
                };
              })
              .filter(function (e) {
                return e.domanda != "";
              });
            self.count(self.model.domande);
            controlChek();
            controlRadio();
          })
          .catch(function (error) {
            console.error("Errore: ", error);
          });

      }

      self.count = function (domande) {
        domande.forEach(function(domanda) {
          domanda.risposte.forEach(function(risposta) {
            if(risposta.selected === true){
              self.numberOfQuestionsSelected = self.numberOfQuestionsSelected + 1;
            }
          })
        }) 
      }

  
      self.checkIfIseveryQuestionAnswered = function () {
        
        var allQuestionChecked = self.numberOfCheckSelected
          .every(function(e){
            return e==true;
          })
        var allQuestionRadio = self.numberOfRadioSelected
          .every(function(e){
              return e==true;
          })
        var totalNumberOfRadio = self.model.domande &&
        self.model.domande
          .filter(function(element){ 
            return element.tipo == "radio"
          })

        var totalNumberOfCheck = self.model.domande &&
        self.model.domande
          .filter(function(element){ 
            return element.tipo == "checkbox"
          })
        if(allQuestionRadio && allQuestionChecked && (self.numberOfCheckSelected.length == totalNumberOfCheck.length) && (self.numberOfRadioSelected.length == totalNumberOfRadio.length)) {
          self.isEveryQuestionAnswered({everyQuestionAnswered: true});
        }else{
          self.isEveryQuestionAnswered({everyQuestionAnswered: false});
        }
        
      }

      self.check = function (el) {
        el.selected = !el.selected;
        controlChek();
      }

      var controlChek = function(){
        self.numberOfCheckSelected=[];
        self.model.domande
          .filter(function(element){ 
            return element.tipo == "checkbox"
          }).forEach(function(f, index){
            self.numberOfCheckSelected[index]= f.risposte.some(function(s){
              return s.selected == true
            })
          })
        self.checkIfIseveryQuestionAnswered();
      }

      var controlRadio = function(){
        self.numberOfRadioSelected=[];
        self.model.domande
          .filter(function(element){ 
            return element.tipo == "radio"
          }).forEach(function(f, index){
            self.numberOfRadioSelected[index]= f.risposte.some(function(s){
              return s.selected == true
            })
          })
        self.checkIfIseveryQuestionAnswered();
      }


      self.sendMail = function(){
        self.loaderSendMail=true;
        $userService.sendQvaCruscotto(self.model.domande, self.model.codQuestionario, self.contractSelected.prodotto, self.numeroContratto, self.modulo)
        .then(function(response){
          self.esito = response.esito;
          $modalService.openModal("qva-modal-adeguatezza");
        })
        .catch(function(error){
          console.log(error);
          self.loaderSendMail=false;
        })
      }

      self.closeModal = function() {
        $modalService.closeModal();
        self.loaderSendMail=false;
      }

      self.confermModalAdeguatezza = function(){
        $userService.submitQva(self.contractSelected, self.model, true)
        .then(function(response){
          if(response.success){
            $modalService.closeModal();
            $rootScope.$broadcast('addAlert', {
              text: 'LBL_SUBMIT_QVA_OK'
            });
            $modalService.closeModal();
            self.loaderSendMail=false;
            $location.path('/');
          }
          self.loaderSendMail=false;
        })
        .catch(function(error){
          console.log(error);
          $modalService.closeModal();
          self.loaderSendMail=false;
        })
        
      }

      
    }
  });
